import { colors as materialUiColors } from 'material-ui/styles';

const baseColors = {
    gray40: '#F8F8F8',
    grey50: '#FAFAFA',
    grey100: '#F5F5F5',
    lightestGrey: '#F0F0F0',
    greyishPink: '#E6E5E5',
    grey300: '#E0E0E0',
    beigeWhite: '#E4E4E4',
    lightBgGrey: '#EDEDED',
    grey325: '#dfdfdf',
    grey350: '#CACACA',
    grey400: '#BDBDBD',
    lightGrey: '#BBBBBB',
    grey500: '#9E9E9E',
    grey: '#A5A5A5',
    darkGrey: '#818181',
    landingLinkGrey: '#919191',
    linkSectionGrey: '#999999',
    greyTheme: '#666666',
    grey700: '#616161',
    grey750: '#515151',
    grey800: '#424242',
    darkerGrey: '#393939',
    heroGrey: '#404040',
    projectsGrey: '#343333',
    darkestGrey: '#272727',
    lightestBlue: '#E7F1FD',
    lightBlue: '#60A4F4',
    lightBlueA700: '#0091EA',
    lightLinkBlue: '#3289F1',
    mediumBlue: '#488AEA',
    linkBlue: '#1D5CDE',
    darkBlue: '#4D5481',
    lightTurquois: '#aefcdc',
    turquois: '#058789',
    lightPurple: '#A81CA6',
    purple: '#690596',
    red200: '#EF9A9A',
    red: '#E91751',
    red500: '#F44336',
    red600: '#E53935',
    limeGreen: '#66DE75',
    lightGreen: '#4DC55C',
    lightestGreen: '#89C774',
    brightGreen: '#00C33E',
    green400: '#66BB6A',
    green: '#4DA24B',
    amber600: '#FFB300',
    orange: '#E69D00',
    amber800: '#FF8F00',
    darkYellow: '#caca03',
    yellow500: '#e8a200',
};

export const colors = {
    ...materialUiColors,
    ...baseColors,
};
